import { useEffect } from 'react';
import { parseEventMessage } from '../utils/parser';

export function useWebViewPostMessage<T>({
  eventName,
  handler,
}: {
  eventName: string;
  handler: (data: T) => void;
}) {
  useEffect(() => {
    const handleEvent = (nativeEvent: MessageEvent) => {
      try {
        const data = parseEventMessage(nativeEvent.data as string);

        if (data && data.eventName === eventName) {
          handler(data.params as T);
        }
      } catch (e) {
        console.error(e);
      }
    };

    window.addEventListener('message', handleEvent, true);
    return () => window.removeEventListener('message', handleEvent, true);
  }, [handler]);

  return null;
}
